/**
 * **C06 · The finance-year calendar** (Stream C, Documents.dc.html): the 11×17 poster by the finance
 * director's desk — every dated obligation of a fiscal year, month by month, and who. The rows are
 * The finance year's own (`GET /money/finance-year/:fy`), in date order; a row that waits on a Year
 * setting has no month yet and says so. The approvals waiting on a director are a day's, not a
 * year's, and stay off the wall.
 */
import { NO_DATA, type PaperPage } from './paper_page.js';

const MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export interface PosterStep {
  key: string;
  obligation: string;
  sub: string;
  due: string | null;
  who: string;
}

/** `fy` is the fiscal year on the wall: July of the year before through June. */
export function financeYearPoster(fy: number, steps: readonly PosterStep[] | null): PaperPage {
  const rows = steps
    ? [...steps]
        .filter((s) => !s.key.startsWith('approval:'))
        .sort((a, b) => (a.due ?? '9').localeCompare(b.due ?? '9'))
        .map((s) => [
          s.due ? (MON[Number(s.due.slice(5, 7)) - 1] ?? '') : '—',
          s.sub ? `${s.obligation} · ${s.sub}` : s.obligation,
          s.who,
        ])
    : [['', NO_DATA, '']];
  return {
    title: `The finance year · ${String(fy - 1)} – ${String(fy).slice(2)}`,
    sub: 'Every dated obligation · who · the law or the setting it comes from',
    blocks: [{ head: '', cols: '60px 1fr 110px', rows }],
    foot: 'Finance-year poster · reprint when a Year setting changes a date',
  };
}
